<template>
    <div style="">
        <hd-header></hd-header>
        <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 50px;padding-top: 50px;">
            <div style="width:1200px">
                <el-container style="padding-top: 50px;">
                    <el-aside width="220px">
                        <hd-aside></hd-aside>
                    </el-aside>
                    <el-main style="padding-top: 0;padding-bottom: 0;">
                        <el-card shadow="never" style="border: 0;height: 100%;">
                            <p class="pTitle">学校申请</p>
                            <p style="margin-top: 30px;margin-bottom: 30px;">
                                <el-button type="primary" style="width: 150px;" @click="joined()">立即申请</el-button>
                            </p>
                            <el-tabs v-model="activeName" @tab-click="clickTab">
                                <el-tab-pane label="已加入学校" name="joined">
                                    <ul class="ulJoined">
                                        <li v-for="(eachLine, indexOfEachLine) in joinedSchools" :key="indexOfEachLine">
                                            <div class="divJoinedSchool">
                                                <el-row>
                                                    <el-col :span="10">
                                                        <p
                                                            style="text-align: center;margin: 0;padding: 0;line-height: 0;">
                                                            <el-image :src="eachLine.school_logo"
                                                                      style="border-radius: 50%;height: 60px;width:60px;">
                                                                <div slot="error" class="image-slot"
                                                                     style="text-align: center;">
                                                                    <el-image :src="defaultSchoolLogo"
                                                                              class="imgAvatar"></el-image>
                                                                </div>
                                                            </el-image>
                                                        </p>
                                                        <p
                                                            style="text-align: center;margin: 0.5em 0 0 0;padding: 0;line-height: 25px;">
                                                            {{ eachLine.school_name }}
                                                        </p>
                                                    </el-col>
                                                    <el-col :span="14">
                                                        <p style="color:#999999;text-align: right;margin-right: 2em;">
                                                            申请身份：<span style="color: #000000;">{{
                                                                eachLine.role_show
                                                            }}</span>
                                                        </p>
                                                        <p style="color:#999999;text-align: right;margin-right: 2em;">
                                                            申请日期：{{ eachLine.create_Ymd }}
                                                        </p>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </li>
                                    </ul>
                                    <div style="clear: both;"></div>
                                </el-tab-pane>
                                <el-tab-pane label="申请列表" name="applying">
                                    <el-table :data="applySchools" stripe>
                                        <el-table-column prop="school_name" label="申请学校名称" width=""></el-table-column>
                                        <el-table-column prop="create_time_show" label="申请时间"
                                                         width=""></el-table-column>
                                        <el-table-column prop="role_show" label="申请身份" width=""></el-table-column>
                                        <el-table-column prop="status_show" label="审批状态" width=""></el-table-column>
                                        <el-table-column label="操作" width="">
                                            <template slot-scope="scope">
                                                <el-button type="text" size="small" v-if="scope.row.status === -1"
                                                           @click="reapply(scope.row)">重新申请
                                                </el-button>
                                                <el-button type="text" size="small" v-if="scope.row.status === -1"
                                                           @click="cancelApply(scope.row)">取消申请
                                                </el-button>
                                                <span v-if="scope.row.status !== -1">-</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-tab-pane>
                            </el-tabs>
                        </el-card>
                    </el-main>
                </el-container>
            </div>
        </div>
        <hd-footer></hd-footer>
        <el-dialog title="加入学校" :visible.sync="dialogJoinedSchool" width="520px">
            <el-form label-position="right" label-width="80px">
                <el-form-item label="加入身份:" style="margin-top: 1em;margin-bottom: 0.5em;" v-if="currentId === 0">
                    <span v-if="!isTeacher">学生</span>
                    <el-radio-group v-model="joinedType" v-if="isTeacher">
                        <el-radio label="1">教师</el-radio>
                        <el-radio label="0">学生</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="加入身份:" style="margin-top: 1em;margin-bottom: 0.5em;" v-if="currentId > 0">
                    <span v-if="applyRole === 0">学生</span>
                    <span v-if="applyRole === 1">教师</span>
                </el-form-item>
                <el-form-item label="学校名称:">
                    <sub-school @getSchoolId="fetchSchoolId" :selectedSchoolName="schoolName"
                                v-if="currentId === 0"></sub-school>
                    <span v-if="currentId > 0">{{ schoolName }}</span>
                </el-form-item>
                <el-form-item label="申请理由:" style="margin-bottom: 0;">
                    <el-input type="textarea" rows="5" v-model="applyExcuse"></el-input>
                </el-form-item>
                <el-form-item label="审核反馈:" style="margin-bottom: 0;" v-if="currentId > 0">
                    <span style="color: #f56c6c;">{{ reason }}</span>
                </el-form-item>
                <el-form-item label="">
                    <el-checkbox label="我同意管理员查看我的实名信息" size="small" v-model="isAgree" style="color: #999999;">
                    </el-checkbox>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" plain="plain" size="mini" @click="joinedCancel()">取消</el-button>
                <el-button type="primary" size="mini" @click="joinedCommit()">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import HdHeader from '../public/Header.vue'
import HdFooter from '../public/FooterLogined.vue'
import HdAside from '../public/Aside.vue'
import SubSchool from '../public/sub/SubSchool.vue'

export default {
    name: 'UserJoinSchool',
    components: {
        HdHeader,
        HdFooter,
        HdAside,
        SubSchool
    },
    created () {
        this.defaultSchoolLogo = this.getServerUrl() + '/static/images/user.jpg'
        this.getUserInfo()
        this.getApplyList()
        this.getList()
    },
    data () {
        return {
            activeName: 'joined',
            joinedSchools: [],
            applySchools: [],
            dialogJoinedSchool: false,
            joinedType: '1',
            isAgree: false,
            schoolName: '',
            schoolId: 0,
            userInfo: {},
            isTeacher: 0,
            applyExcuse: '',
            currentId: 0,
            reason: '',
            defaultSchoolLogo: '',
            applyRole: 0
        }
    },
    methods: {
        getApplyList () {
            let that = this
            this.$ajax.get('/api/schooluserapply/getlist', {
                params: {
                    order: 'desc',
                    per_page: 20
                }
            }).then(function (r) {
                that.applySchools = r.data.items
            })
        },
        getList () {
            let that = this
            this.$ajax.get('/api/schooluser/getlist', {
                params: {
                    order: 'desc',
                    per_page: 20
                }
            }).then(function (r) {
                that.joinedSchools = r.data.items
            })
        },
        getUserInfo () {
            let that = this
            this.$ajax.get('/api/user/get').then(function (r) {
                that.form = r.data
                that.isTeacher = r.data.is_teacher
            })
        },
        clickTab (tab, event) {
            console.log(tab.name)
        },
        reapply (row) {
            this.currentId = row.id
            this.schoolId = row.school_id
            this.schoolName = row.school_name
            this.applyExcuse = row.apply_excuse
            this.applyRole = row.role
            this.reason = row.reason
            this.dialogJoinedSchool = true
        },
        joined () {
            //重置数据
            if (this.isTeacher) {
                this.joinedType = '1'
            }
            this.isAgree = false
            this.currentId = 0
            this.schoolId = 0
            this.schoolName = ''
            this.applyExcuse = ''
            this.reason = ''
            this.dialogJoinedSchool = true
        },
        joinedCancel () {
            this.dialogJoinedSchool = false
        },
        joinedCommit () {
            if (this.schoolId === 0) {
                this.showError('请选择学校')
                return
            }
            if (this.isEmpty(this.applyExcuse)) {
                this.showError('请输入理由')
                return
            }
            if (!this.isAgree) {
                this.showError('您还未同意查看实名信息')
                return
            }
            let role = 0
            if (this.isTeacher) {
                role = this.joinedType
            }
            let that = this
            if (this.currentId === 0) {
                this.$ajax.post('/api/schooluserapply/create', {
                    school_id: this.schoolId,
                    role: role,
                    apply_excuse: this.applyExcuse
                }).then(function (r) {
                    that.dialogJoinedSchool = false
                    that.$message.success('已提交申请')
                    //更新
                    that.getApplyList()
                })
            } else {
                this.$ajax.post('/api/schooluserapply/update', {
                    id: this.currentId,
                    school_id: this.schoolId,
                    role: role,
                    apply_excuse: this.applyExcuse,
                    status: 0
                }).then(function (r) {
                    that.dialogJoinedSchool = false
                    that.$message.success('已提交申请')
                    //更新
                    that.getApplyList()
                })
            }
        },
        fetchSchoolId: function (schoolId) {
            this.schoolId = schoolId
        },
        cancelApply: function (row) {
            let that = this
            this.$confirm('此操作将取消该申请，是否继续？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$ajax.post('/api/schooluserapply/update', {
                    id: row.id,
                    status: 3
                }).then((r) => {
                    //删除记录
                    that.getApplyList()
                    that.showSuccess('取消成功')
                })
            })
        }
    }
}
</script>

<style>
body {
    background-color: #F8F8F8;
}

.pTitle {
    border-bottom: 1px solid #d6d6da;
    padding-bottom: 10px;
}

.divJoinedSchool {
    background-color: #fdfdfd;
    border: 1px solid #eaeaee;
    border-radius: 5px;
    padding-top: 1em;
    padding-bottom: 1em;
}

.ulJoined {
    list-style: none;
    margin: 0;
    padding: 0;
}

.ulJoined li {
    width: 410px;
    float: left;
    margin-top: 1em;
    padding: 0;
    margin-left: 1em;
    margin-right: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserJoinSchool.vue